import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureApiClient } from '@thesis3/api-client';
import { App } from './App';
import { getAccessToken, refreshSession } from './auth/oidc';
import { platformReady, store } from './store';
import './index.css';

/**
 * Boot wiring: the shell configures the shared api-client EXACTLY ONCE with
 * its OIDC-backed token supplier. Federated feature apps import the ready-made
 * axiosBaseQuery from @thesis3/api-client and never see tokens.
 */
configureApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://localhost:8443',
  getAccessToken,
  refresh: refreshSession,
});
store.dispatch(platformReady());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
